import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { CheckCircle2, LogIn } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

export default function Ack() {
  const { token } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  useEffect(() => { axios.get(`${API}/api/ack/${token}`).then((r) => setData(r.data)).catch((e) => setErr(e?.response?.data?.detail || "This link is invalid.")); }, [token]);
  if (err) return <div className="min-h-screen bg-[#f3f4f6] flex items-center justify-center p-6"><div className="trk-card max-w-md text-rose-700" data-testid="ack-error">{err}</div></div>;
  if (!data) return <div className="min-h-screen bg-[#f3f4f6] flex items-center justify-center text-slate-500">Confirming…</div>;
  return (
    <div className="min-h-screen bg-[#f3f4f6] text-slate-900" data-testid="ack-page">
      <header className="bg-[#0b1f3a] text-white px-5 py-4"><div className="max-w-xl mx-auto"><div className="text-[11px] uppercase tracking-[0.2em] text-white/60">{data.company}</div><div className="text-xl font-bold">Assignment confirmed</div></div></header>
      <main className="max-w-xl mx-auto p-5 space-y-4">
        <div className="trk-card flex items-start gap-3 bg-emerald-50 border-emerald-200" data-testid="ack-done">
          <CheckCircle2 className="h-8 w-8 text-emerald-700 shrink-0" />
          <div>
            <div className="font-bold text-emerald-900">{data.already ? "Already acknowledged" : "Thanks, " + (data.server_name || "").split(" ")[0] + "!"}</div>
            <div className="text-sm text-emerald-800">{data.company} can now see you've received job <b data-testid="ack-job-number">{data.job_number}</b> — {data.recipient_name}{data.recipient_address ? `, ${data.recipient_address}` : ""}.</div>
          </div>
        </div>
        <a href={data.job_url} className="inline-flex items-center gap-2 rounded-full bg-[#0f3d2a] text-white px-5 py-2.5 text-sm font-semibold" data-testid="ack-open-job"><LogIn className="h-4 w-4" />Open the job in Simply Served</a>
      </main>
    </div>
  );
}
